import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import Rooms from './Rooms'

export default function RoomsModal({ opened, onClose, ...rest }) {
    const isMobile = useMediaQuery('(max-width: 50em)')

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Rooms"
            size="xl"
            fullScreen={isMobile}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                },
                body: {
                    padding: 0,
                    height: isMobile ? '100%' : 'auto',
                    maxHeight: isMobile ? '100%' : '70vh',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <Rooms />
        </Modal>
    )
}

